// Groups the guide's fine-grained sections into a few digestible modal steps.
// Keep this to 3–4 chapters per role so the wizard never overwhelms a new user.

export interface GuideChapter {
  id: string;
  titleKey: string;
  /** Section ids (from guideContent.*) rendered on this modal step, in order. */
  sectionIds: string[];
}

export const employerChapters: GuideChapter[] = [
  {
    id: 'register',
    titleKey: 'guide.chapter.employer.register',
    sectionIds: ['obligations', 'register'],
  },
  {
    id: 'money',
    titleKey: 'guide.chapter.employer.money',
    sectionIds: ['procedure', 'insurance', 'rates'],
  },
  {
    id: 'contract',
    titleKey: 'guide.chapter.employer.contract',
    sectionIds: ['contract', 'deadlines'],
  },
  {
    id: 'setup',
    titleKey: 'guide.chapter.employer.setup',
    sectionIds: ['documents', 'done'],
  },
];

export const employeeChapters: GuideChapter[] = [
  {
    id: 'meaning',
    titleKey: 'guide.chapter.employee.meaning',
    sectionIds: ['meaning'],
  },
  {
    id: 'protections',
    titleKey: 'guide.chapter.employee.protections',
    sectionIds: ['insurance', 'rights', 'multiple'],
  },
  {
    id: 'wrapup',
    titleKey: 'guide.chapter.employee.app',
    sectionIds: ['done'],
  },
];
